import { call } from "redux-saga/effects";

import { Api, ConfigurationManager } from "@/utils";

/**
 * Saves the floor space payload (lights and settings) to the API and returns the updated data.
 *
 * @param payload - The floor space data payload to save.
 * @returns The updated floor space data, or null on error.
 * @yields Calls the API to save floor space data.
 */
function* saveToApi(payload) {
    try {
        yield call(Api.put, "v1/floor-spaces/with-lights-and-delete-ids/", [
            payload,
        ]);
        const { floorSpaceId } = ConfigurationManager.values;
        const response = yield call(
            Api.get,
            `v1/floor-spaces/${floorSpaceId}/with-lightsmaps`,
        );
        return response;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log(`save to api saga: ${err}`);
        return null;
    }
}

export default saveToApi;
